var map = {
	"./Carousel": 9253,
	"./Carousel.jsx": 9253,
	"./Not-Found": 5027,
	"./Not-Found.jsx": 5027,
	"./Not-Found.module.css": 4409,
	"./images/Sticky-date.webp": 4134,
	"./images/choc-cake.webp": 1384,
	"./images/choc-croissant.webp": 1020,
	"./images/coffee-cardamom.webp": 1247,
	"./images/coffee-cardamom2.webp": 2431,
	"./images/find-left.webp": 1643,
	"./images/find-middle.webp": 3251,
	"./images/find-right.webp": 4852,
	"./images/pre-croissants.webp": 1341,
	"./images/story-left.webp": 8049,
	"./images/story-middle.webp": 3053,
	"./images/story-right.webp": 5570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4568;